"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VaccinationType = void 0;
exports.instanceOfVaccinationType = instanceOfVaccinationType;
exports.VaccinationTypeFromJSON = VaccinationTypeFromJSON;
exports.VaccinationTypeFromJSONTyped = VaccinationTypeFromJSONTyped;
exports.VaccinationTypeToJSON = VaccinationTypeToJSON;
exports.VaccinationTypeToJSONTyped = VaccinationTypeToJSONTyped;
/**
 *
 * @export
 */
exports.VaccinationType = {
    Covid19: 'COVID_19',
    Hepatitis: 'HEPATITIS',
    Influenza: 'INFLUENZA',
    MeaslesMumpsRubella: 'MEASLES_MUMPS_RUBELLA',
    Tdap: 'TDAP',
    Varicella: 'VARICELLA'
};
function instanceOfVaccinationType(value) {
    for (const key in exports.VaccinationType) {
        if (Object.prototype.hasOwnProperty.call(exports.VaccinationType, key)) {
            if (exports.VaccinationType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function VaccinationTypeFromJSON(json) {
    return VaccinationTypeFromJSONTyped(json, false);
}
function VaccinationTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function VaccinationTypeToJSON(value) {
    return value;
}
function VaccinationTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=VaccinationType.js.map